import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import IconMerchantRed from '@static/images/icon_merchant_red.svg'
import IconMerchantBlue from '@static/images/icon_merchant_blue.svg'
import IconMerchantOrange from '@static/images/icon_merchant_orange.svg'
import IconMerchantGreen from '@static/images/icon_merchant_green.svg'
import IconMerchantBlack from '@static/images/icon_merchant_black.svg'
import IconMerchantBronze from '@static/images/icon_merchant_bronze.svg'
import IconMerchantSilver from '@static/images/icon_merchant_silver.svg'
import IconMerchantGold from '@static/images/icon_merchant_gold.svg'
import IconMerchantWhite from '@static/images/icon_merchant_white.svg'
import IconMerchantPurple from '@static/images/icon_merchant_purple.svg'
import IconMerchantMysticBlue from '@static/images/icon_merchant_mysticblue.svg'
import IconMerchantPink from '@static/images/icon_merchant_pink.svg'
import {type PlayerColorWithoutNone} from '../../../utils/gameColors.ts'

const PLAYER_COLOR_TO_MERCHANT_ICON: Record<PlayerColorWithoutNone, ImageURL> = {
    [PlayerColor.Red]: IconMerchantRed,
    [PlayerColor.Blue]: IconMerchantBlue,
    [PlayerColor.Orange]: IconMerchantOrange,
    [PlayerColor.Green]: IconMerchantGreen,
    [PlayerColor.Black]: IconMerchantBlack,
    [PlayerColor.Bronze]: IconMerchantBronze,
    [PlayerColor.Silver]: IconMerchantSilver,
    [PlayerColor.Gold]: IconMerchantGold,
    [PlayerColor.White]: IconMerchantWhite,
    [PlayerColor.Purple]: IconMerchantPurple,
    [PlayerColor.MysticBlue]: IconMerchantMysticBlue,
    [PlayerColor.Pink]: IconMerchantPink,
} as const

export const useMerchantIcon = (playerColor: PlayerColorWithoutNone) => PLAYER_COLOR_TO_MERCHANT_ICON[playerColor]
